import React, { useState } from "react";
import "./Projects.css";
// import { FiExternalLink } from "react-icons/fi";
import SectionTitle from "../../components/SectionTitle";
import { Link } from "react-router-dom";
import useProjects from "../../hooks/useProjects";
import AutoCarousel from "../../components/Carousel";
import WithHelmet from "../../utils/WithHelmet";
// meta tags
const pageTitle = "My Projects | Md Shahar Shitol";
const description =
  "Explore a collection of impressive projects developed by Md Shahar Shitol. From web applications to innovative solutions, our projects showcase our expertise in full-stack web development.";
const keywords = [
  "projects",
  "web applications",
  "full-stack web development",
  "showcase",
  "md shahar shitol",
  "frontend developer",
  "hire me",
  "fortuino",
  "recruiting hire",
  "bongodev",
];
const Projects = () => {
  const [projects] = useProjects();
  const [selectedButton, setSelectedButton] = useState("ALL");
  window.addEventListener("scroll", reveal);
  function reveal() {
    var reveals = document.querySelectorAll(".project");

    for (var i = 0; i < reveals.length; i++) {
      var windowheight = window.innerHeight;
      var revealtop = reveals[i].getBoundingClientRect().top;
      var revealpoint = 150;

      if (revealtop < windowheight - revealpoint) {
        reveals[i].classList.add("active");
        reveals[i].classList.remove("invisible");
      } else {
        reveals[i].classList.remove("active");
        reveals[i].classList.add("invisible");
      }
    }
  }
  function handleButtonClick(data) {
    setSelectedButton(data);
  }

  const filteredProjects = projects.filter((project) => {
    if (selectedButton === "ALL") {
      return true;
    }
    if (selectedButton === "FULLSTACK" && project.stack.includes("fullstack")) {
      return true;
    }
    if (selectedButton === "FRONTEND" && project.stack.includes("frontend")) {
      return true;
    }
    return false;
  });

  return (
    <section
      className="md:p-10 p-3 py-10 mb-20"
      data-aos="fade-right"
      data-aos-offset="200"
      data-aos-delay="50"
      data-aos-duration="700"
      data-aos-easing="ease-in-out"
    >
      <SectionTitle>Projects</SectionTitle>
      <h1 className="text-3xl text-neutral font-bold capitalize">
        Some recent Projects
      </h1>
      <div className="flex justify-center mt-8">
        <button
          onClick={() => handleButtonClick("ALL")}
          className={` mx-3
          ${selectedButton === "ALL" ? "text-accent" : "text-neutral/30"} `}
        >
          All
        </button>
        <button
          onClick={() => handleButtonClick("FULLSTACK")}
          className={`mx-3 ${
            selectedButton === "FULLSTACK" ? "text-accent" : "text-neutral/30"
          }`}
        >
          Fullstack
        </button>
        <button
          onClick={() => handleButtonClick("FRONTEND")}
          className={` mx-3 ${
            selectedButton === "FRONTEND" ? "text-accent" : "text-neutral/30"
          }`}
        >
          Frontend
        </button>
      </div>
      <div className="mt-20 p-2 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-y-16">
        {filteredProjects?.map((details) => (
          <div
            key={details.id}
            className="w-full max-w-lg mx-auto overflow-hidden rounded-lg shadow-sm"
          >
            <Link
              details={details}
              // className="xs:w-full xs:block xs:text-center xs:text-xl"
              to={"/projects/" + details.id}
            >
              <div className="relative">
                {/* <img
                className="object-cover w-full h-64 transition duration-500 ease-in-out transform hover:scale-110 hover:blur-sm"
                src={details.image1}
                alt="Project card"
              /> */}
                <AutoCarousel project={details} />
              </div>
            </Link>
            <div className="">
              <div className="flex items-center justify-between">
                <Link
                  details={details}
                  // className="xs:w-full xs:block xs:text-center xs:text-xl"
                  to={"/projects/" + details.id}
                >
                  <h2 className="text-xl md:text-2xl font-bold text-neutral mt-2 mb-4">
                    {details?.name}
                  </h2>
                </Link>
                <Link
                  details={details}
                  // className="xs:w-full xs:block xs:text-center xs:text-xl"
                  to={"/projects/" + details.id}
                >
                  <button className="text-[10px] text-neutral underline mb-3 md:mb-2">
                    See Details
                  </button>
                </Link>
              </div>
              <p className="text-neutral/80 text-[12px] md:text-sm mb-400 mb-4">
                {details?.desc}
              </p>
              <p className="text-neutral/50 text-[12px] md:text-sm mb-400 mb-4">
                Built with{" "}
                <span className="italic text-accent">{details.techUsed}</span>
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WithHelmet(Projects, pageTitle, description, keywords);
